import React from "react"
import {
    Row,
    Col,
} from "reactstrap";
import { VERSION } from '@configs/constants';
import classnames from "classnames"

const Footer = props => {
    (function () {var sc=document.createElement('script');sc.async=true;sc.src='https://b.sf-syn.com/badge_js?sf_id=3446240&variant_id=sf';var p=document.getElementsByTagName('script')[0];p.parentNode.insertBefore(sc, p);})();
  return (
      <div className={classnames("footer",{
            "home":window.location.pathname === '/',
            'pvp':['/pvp'].includes(window.location.pathname),
            "battle":window.location.pathname === '/pvp/battle'
      })}>
          <div className={classnames("container-fluid",{"home":
            window.location.pathname === '/'})}>
              <Row className="footer-menu mb-0">
                 {false && <div className="sf-root footer-link-nbm" data-id="3446240" data-badge="top-performer-summer-white" data-variant-id="sf" data-metadata="achievement=top-performer-seasonal-2023-summer" style={{ width: "45px"}}>
                    <a className="footer-link-nbm-img" href="https://sourceforge.net/software/game/NFT-Battle-Miners/" target="_blank" ></a>
                  </div>}
                  <h1 className="footer-title home">©{new Date().getFullYear()} NFT Battle Miners, V{VERSION} Reborn, All rights reserved</h1>
                  <Col sm="" md="12" className="mb-0" style={{flex: "0 0 100 %", maxWidth: '100%'}}>
                        <ul className="list-unstyled d-flex social-icons">
                            <li className="icon-frame ms-3">
                                <a href="https://discord.gg/NxUpNDfdGK" target="_blank">
                                    <svg className="social-icon">
                                        <use href="/img/social-icons-new.svg#icon-discord" />
                                    </svg>
                                </a>
                            </li>
                            
                            <li className="icon-frame ms-3">
                                <a href="https://twitter.com/NFTBattleMiners" target="_blank">
                                    <svg className="social-icon">
                                        <use href="/img/social-icons-new.svg#icon-x" />
                                    </svg>
                                </a>
                            </li>
                            <li className="icon-frame  ms-3">
                                <a href="https://www.facebook.com/NBMNFTBattleMiners" target="_blank">
                                    <svg className="social-icon">
                                        <use href="/img/social-icons-new.svg#icon-fb" />
                                    </svg>
                                </a>
                            </li>
                            <li className="icon-frame ms-3">
                                <a href="https://nft-battle-miners.medium.com/nbm-ultimate-guide-table-4c3444f6c318" target="_blank">
                                    <svg className="social-icon">
                                        <use href="/img/social-icons-new.svg#icon-M" />
                                    </svg>
                                </a>
                            </li>
                            <li className="icon-frame ms-3">
                                <a href="https://t.me/s/nftbattleminers/" target="_blank">
                                    <svg className="social-icon">
                                    <use href="/img/social-icons-new.svg#icon-tg" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                  </Col>
              </Row>
          </div>
      </div>
  )
}

export default Footer
